export default __webpack_public_path__ + "static/media/duser.73a0bc1f.png";